module.exports = __webpack_public_path__ + "static/media/logo_cloud.60ef9bbe.png";